// kufer-favorites.js

// Globales Array im Memory, damit alle Scripte denselben Stand teilen
let userFavoriteKNRs = [];

/**
 * Lädt die Favoriten des angemeldeten Users aus den WordPress-Settings
 */
export function loadUserFavorites() {
  const isUserLoggedIn = document.body.classList.contains("logged-in");

  if (
    isUserLoggedIn &&
    typeof wpApiSettings !== "undefined" &&
    Array.isArray(wpApiSettings.favorites)
  ) {
    userFavoriteKNRs = [...wpApiSettings.favorites];
  } else {
    userFavoriteKNRs = [];
  }
  return userFavoriteKNRs;
}

/**
 * Aktualisiert das visuelle Erscheinungsbild eines einzelnen Buttons basierend auf der KNR
 */
export function updateFavButtonVisual(favBtn, knr) {
  if (!favBtn) return;

  const isFav = userFavoriteKNRs.includes(knr);
  const icon = favBtn.querySelector(".fav-icon");

  if (isFav) {
    favBtn.classList.add("is-favorite");
    if (icon) icon.textContent = "favorite";
  } else {
    favBtn.classList.remove("is-favorite");
    if (icon) icon.textContent = "favorite_border";
  }
}

/**
 * Kern-Funktion für das Senden des Favoriten-Status an die WordPress-API.
 * Kann von überall aufgerufen werden.
 *
 * Aktualisiert das Icon OPTIMISTISCH, noch bevor die Server-Antwort da ist:
 * Ein Favoriten-Toggle ist ein authentifizierter WP-REST-Call (Nonce-Pruefung,
 * eingeloggter User) und kann daher NICHT ueber das schnelle, ungebootstrapte
 * kufer-api.php laufen - der volle WordPress-Bootstrap braucht spuerbare Zeit
 * (auf Produktiv-Hosting typischerweise mehr als lokal). Ohne sofortiges
 * visuelles Feedback fuehlt sich der Klick in dieser Zeit wie "nichts passiert"
 * an. Schlaegt der Request fehl, wird die optimistische Änderung zurückgerollt.
 */
export function toggleFavoriteRequest(knr, favBtn, onStatusChanged = null) {
  if (typeof wpApiSettings === "undefined" || !wpApiSettings.nonce) {
    alert("Bitte logge dich ein, um Kurse auf deiner Merkliste zu speichern.");
    return Promise.reject("Not logged in");
  }

  const wasFavorite = userFavoriteKNRs.includes(knr);

  const setLocalFavoriteState = (isFavorite) => {
    if (isFavorite) {
      if (!userFavoriteKNRs.includes(knr)) userFavoriteKNRs.push(knr);
    } else {
      userFavoriteKNRs = userFavoriteKNRs.filter((id) => id !== knr);
    }
    updateFavButtonVisual(favBtn, knr);
  };

  // 1. Sofort umschalten, bevor die Antwort da ist.
  setLocalFavoriteState(!wasFavorite);

  return fetch(
    `${window.location.origin}/wp-json/mmmake-kufer/v2/user/favorites`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-WP-Nonce": wpApiSettings.nonce,
      },
      body: JSON.stringify({ knr: knr }),
    },
  )
    .then((response) => {
      if (!response.ok) throw new Error(`Netzwerkfehler: ${response.status}`);
      return response.json();
    })
    .then((data) => {
      // Server-Antwort ist die Wahrheit: nur korrigieren, falls sie (z.B. durch
      // ein zweites offenes Tab) von unserer Annahme abweicht.
      setLocalFavoriteState(data.status === "added");

      // Optionaler Callback für Spezialfälle (z.B. Ausblenden in der Merkliste)
      if (typeof onStatusChanged === "function") {
        onStatusChanged(data.status);
      }
      return data;
    })
    .catch((error) => {
      // Request fehlgeschlagen: optimistische Änderung zurückrollen.
      setLocalFavoriteState(wasFavorite);
      console.error("Fehler beim Favorisieren:", error);
    });
}

/**
 * Initialisiert eigenständige Favoriten-Buttons (z.B. auf der Detailseite)
 * Sucht nach Elementen mit [data-kufer-fav-detail="KNR_HIER"]
 */
export function initializeDetailFavorites() {
  // Favoriten vorab laden, falls noch nicht geschehen
  if (userFavoriteKNRs.length === 0) {
    loadUserFavorites();
  }

  const detailButtons = document.querySelectorAll("[data-kufer-fav-detail]");

  detailButtons.forEach((favBtn) => {
    const knr = favBtn.getAttribute("data-kufer-fav-detail");
    if (!knr) return;

    // Initialen Status setzen
    updateFavButtonVisual(favBtn, knr);

    // Klick-Event verpassen (falls noch nicht registriert)
    if (!favBtn.dataset.favInitialized) {
      favBtn.dataset.favInitialized = "true";
      favBtn.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        toggleFavoriteRequest(knr, favBtn);
      });
    }
  });
}
